/**
 * Közös szövegek - gombok, általános UI elemek
 *
 * Namespace: common
 */
export const common = {
  // Gombok
  loading: "Betöltés...",
  save: "Mentés",
  cancel: "Mégse",
  back: "Vissza",
  next: "Tovább",
  submit: "Küldés",
  retry: "Próbáld újra",
  close: "Bezárás",
  yes: "Igen",
  no: "Nem",

  // Form
  required: "Kötelező mező",

  // reCAPTCHA
  recaptcha: {
    footerText: "Ez az űrlap reCAPTCHA védelme alatt áll. A Google",
    privacy: "Adatvédelmi szabályzata",
    and: "és",
    terms: "Szolgáltatási feltételei",
    apply: "érvényesek.",
  },
} as const;

export type CommonMessages = typeof common;
